// @flow

import React from "react";
import { List, Map } from "immutable";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import DrawerBody from "./DrawerBody";

type Props = {
  isOpen: boolean,
  isOpenMobile: boolean,
  close: Function,
  items: List<Map<string, any>>,
  classes: Object,
  pathname: string,
  dispatch: (Object) => void,
};

const PrivateSidebar = (props: Props) => {
  return (
    <div>
      <Hidden lgUp>
        <Drawer
          variant="temporary"
          anchor={"left"}
          open={props.isOpenMobile}
          onClose={() => props.close(true)}
          ModalProps={
            { keepMounted: true } // Better open performance on mobile.
          }
        >
          <DrawerBody
            items={props.items}
            pathname={props.pathname}
            dispatch={props.dispatch}
          />
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          variant="persistent"
          anchor={"left"}
          style={{ visibility: props.isOpen ? "visible" : "hidden" }}
          classes={props.classes}
          open={props.isOpen}
        >
          <DrawerBody
            items={props.items}
            pathname={props.pathname}
            dispatch={props.dispatch}
          />
        </Drawer>
      </Hidden>
    </div>
  );
};

export default PrivateSidebar;
